import React, { useRef, useState } from "react";
import useIntersectionObserver from "./hooks/useIntersectionObserver";
import "./style.css";

const Skills = () => {
  const sectionRef = useRef(null);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [showSkills, setShowSkills] = useState(true);

  // Define a callback to be called when the element is intersected
  const handleIntersection = () => {
    setContentLoaded(true);
  };

  useIntersectionObserver(sectionRef, handleIntersection);

  const toggleDisplay = () => {
    setShowSkills(!showSkills);
  };

  return (
    <div
      ref={sectionRef}
      className={`loading-container${
        contentLoaded ? "" : " loading-spinner-container"
      }`}
    >
      {contentLoaded ? (
        <section className="skills fade-in-observer" id="skills">
          <div className="skills-content section-content">
            <p className="section-subtitle">My skills</p>
            <h2 className="h3 section-title">
              Molding User Experiences with Skills Mastery
            </h2>
            <p className="section-text">
              With a keen focus on user-centric design, I blend art and
              functionality using a versatile toolkit, delivering interfaces
              that speak to both needs and aesthetics.
            </p>
            <div
              className={`skills-toggle ${!showSkills ? "active" : ""}`}
              data-toggle-box=""
            >
              <button
                className={`toggle-btn ${showSkills ? "active" : ""}`}
                data-toggle-btn=""
                onClick={toggleDisplay}
              >
                Skills
              </button>
              <button
                className={`toggle-btn ${!showSkills ? "active" : ""}`}
                data-toggle-btn=""
                onClick={toggleDisplay}
              >
                Tools
              </button>
            </div>
          </div>
          <div
            className={`skills-box ${showSkills ? "" : "active"}`}
            data-skills-box=""
          >
            <ul className={`skills-list ${showSkills ? "show" : "hide"}`}>
              <li>
                <div className="skill-card">
                  <div className="tooltip">UX/UI</div>
                  <div className="card-icon">
                    <img alt="UX/UI logo" src="./assets/images/uxui.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">HTML5</div>
                  <div className="card-icon">
                    <img alt="HTML5 logo" src="./assets/images/html5.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">CSS3</div>
                  <div className="card-icon">
                    <img alt="CSS3 logo" src="./assets/images/css3.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">JavaScript</div>
                  <div className="card-icon">
                    <img
                      alt="JavaScript logo"
                      src="./assets/images/javascript.png"
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">TypeScript</div>
                  <div className="card-icon">
                    <img
                      alt="TypeScript logo"
                      src="./assets/images/typescript.png"
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">jQuery</div>
                  <div className="card-icon">
                    <img alt="jQuery logo" src="./assets/images/jquery.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Bootstrap</div>
                  <div className="card-icon">
                    <img
                      alt="Bootstrap logo"
                      src="./assets/images/bootstrap.png"
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Angular</div>
                  <div className="card-icon">
                    <img alt="Angular logo" src="./assets/images/angular.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">React</div>
                  <div className="card-icon">
                    <img alt="React logo" src="./assets/images/react.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Vue</div>
                  <div className="card-icon">
                    <img alt="Vue logo" src="./assets/images/vue.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Firebase</div>
                  <div className="card-icon">
                    <img
                      alt="Firebase logo"
                      src="./assets/images/firebase.png"
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">PugJs</div>
                  <div className="card-icon">
                    <img alt="PugJs logo" src="./assets/images/pugjs.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">SASS</div>
                  <div className="card-icon">
                    <img alt="SASS logo" src="./assets/images/sass.png" />
                  </div>
                </div>
              </li>
            </ul>
            <ul className={`tools-list ${showSkills ? "hide" : "show"}`}>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Figma</div>
                  <div className="card-icon">
                    <img alt="Figma logo" src="./assets/images/figma.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Sketch</div>
                  <div className="card-icon">
                    <img alt="Sketch logo" src="./assets/images/sketch.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Invision</div>
                  <div className="card-icon">
                    <img
                      alt="Invision logo"
                      src="./assets/images/invision.png"
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Lunacy</div>
                  <div className="card-icon">
                    <img alt="Lunacy logo" src="./assets/images/lunacy.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Ajax</div>
                  <div className="card-icon">
                    <img alt="Ajax logo" src="./assets/images/ajax.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Webpack</div>
                  <div className="card-icon">
                    <img alt="Webpack logo" src="./assets/images/webpack.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Git</div>
                  <div className="card-icon">
                    <img alt="Git logo" src="./assets/images/git.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Npm</div>
                  <div className="card-icon">
                    <img alt="Npm logo" src="./assets/images/npm.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Command Line</div>
                  <div className="card-icon">
                    <img
                      alt="Command Line logo"
                      src="./assets/images/command.png"
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">VS Code</div>
                  <div className="card-icon">
                    <img alt="VS Code logo" src="./assets/images/vs-code.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Trello</div>
                  <div className="card-icon">
                    <img alt="Trello logo" src="./assets/images/trello.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">ClickUp</div>
                  <div className="card-icon">
                    <img alt="ClickUp logo" src="./assets/images/clickup.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Slack</div>
                  <div className="card-icon">
                    <img alt="Slack logo" src="./assets/images/slack.png" />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Photoshop</div>
                  <div className="card-icon">
                    <img
                      alt="Photoshop logo"
                      src="./assets/images/photoshop.png"
                    />
                  </div>
                </div>
              </li>
              <li>
                <div className="skill-card">
                  <div className="tooltip">Adobe XD</div>
                  <div className="card-icon">
                    <img
                      alt="Adobe XD logo"
                      src="./assets/images/adobe-xd.png"
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
      ) : (
        <div className="observer_spinner" id="skills"></div>
      )}
    </div>
  );
};

export default Skills;
